/**
 * Calculates distance between two points.
 */
export const calculateDistance = (x1: number, y1: number, x2: number, y2: number) => {
  const xd = x2 - x1;
  const yd = y2 - y1;
  return Math.sqrt(xd * xd + yd * yd);
};
